import React, { Component } from 'react'
import MemberDataService from '../../services/MemberDataService';
import '../../css/BisharatMain.css';
import Moment from 'moment';
import Calendar from 'react-calendar';
import translate from '../../languages/translate';
import PartnerService from '../../services/PartnerService';
import {
    AiOutlineCloseCircle
} from "react-icons/ai";
export default class MemberEdit extends Component {
    constructor() {
        super()
        this.state = {
            oneMember: [],
            partners: [],
            children: [],
            address: '',
            birthdate : new Date(),
            fatherName: '',
            gender: '',
            identity: '',
            isAlive: '',
            isMarried: '',
            motherName: '',
            name: '',
            phoneNumber: '',
            errors: {}
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

    }


onChangeDate = birthdate => this.setState({birthdate});

    componentDidMount() {
        const { match: { params } } = this.props;
        const memberId = params.id;
        MemberDataService.getMember(memberId)
            .then(res => {
                const oneMember = res.data;
                console.log("DATA : ", oneMember)
                this.setState({ oneMember });
                this.setState({ address : oneMember.address });
                this.setState({ birthdate : oneMember.birthdate});
                this.setState({ isAlive : oneMember.isAlive });
                this.setState({ fatherName : oneMember.fatherName });
                this.setState({ gender : oneMember.gender });
                this.setState({ identity : oneMember.identity });
                 this.setState({ isMarried : oneMember.isMarried });
                this.setState({ motherName : oneMember.motherName });
                this.setState({ name : oneMember.name });
                this.setState({ phoneNumber : oneMember.phoneNumber });
            });
        MemberDataService.getPartners(memberId).then(res => {
                const partners = res.data;
                this.setState({ partners });
                console.log(partners)
            })
        MemberDataService.getChildren(memberId)
            .then(res => {
                const children = res.data;
                this.setState({ children });
            })
    }


    editMember(memberData, id) {
        MemberDataService.updateMember(id, memberData)
            .then((response) => {
                alert("Submitted Successfully !");
                // window.open('/family-members', "_self");
            })
            .catch((err) => {

                alert("Error : " + err.response.data.message);
            });
    }


    /* On Change for All Fields */


    onChange = e => {
        this.setState(prev => ({
            ...prev,
            [e.target.name]: e.target.value,
        }))
    }
   

    onSubmit(event) {
        event.preventDefault()

        const newMember = {
            address: this.state.address,
            birthdate: Moment(this.state.birthdate).format('DD-MM-YYYY'),
            fatherName: this.state.fatherName,
            gender: this.state.gender,
            identity: this.state.identity,
            isAlive: this.state.isAlive,
            isMarried: this.state.isMarried,
            motherName: this.state.motherName,
            name: this.state.name,
            phoneNumber: this.state.phoneNumber
        };
        this.editMember(newMember, this.state.oneMember.id);
    }


    showPartner(id) {
        window.location.href = `/family-partners/${id}`;
}
    addPartner(id) {
    window.location.href = `/family-partners/createpartner/${id}`;
}
    gotoAddChild(id) {
    window.location.href =  `/family-members/${id}/childcreate`;
}

    gotoUpalodProfilePicture(id) {
    window.location.href = `/family-members/profile/${id}`;
}

gotoMemberProfile(id) {
        window.location.href = `/family-members/${id}`;
    }

    deletePartner(id) {
      
        PartnerService.deletePartner(id)
            .then((response) => {
                
                window.location.reload();
            })
            .catch((err) => {
            });
    }

    deleteMemberClicked(id) {
        MemberDataService.deleteMember(id)
            .then((response) => {
                window.location.reload();
            })
            .catch((err) => {
            });
    }



    render() {
        return (
            <div className="mainCreate">
                <div className="top-container-forms memberedit">

                    <div className="create-form memberedit-form">

                        <h1>  تعديل ملف :  {this.state.oneMember.name} </h1>

                        <form onSubmit={this.onSubmit}>
                            <div className="form-group-create">
                                <h5> الأسم </h5>
                                <input type="text"
                                    name="name" placeholder={this.state.oneMember.name}
                                    value={this.state.name}
                                    onChange={this.onChange}
                                />

                            </div>
                            <div className="form-group-create">
                                <h5> اسم الأب </h5>
                                <input type="text" className="form-control-form-cont" name="fatherName" placeholder={this.state.oneMember.fatherName}
                                    value={this.state.fatherName}
                                    onChange={this.onChange}

                                />

                            </div>
                            <div className="form-group-create">
                                <h5> اسم الأم </h5>
                                <input type="text" className="form-control-form-cont" name="motherName" placeholder={this.state.oneMember.motherName}
                                    value={this.state.motherName}
                                    onChange={this.onChange}
                                />
                            </div>
                            <div className="form-group-create">
                                <h5> رقم الهاتف </h5>
                                <input type="text" className="form-control-form-cont" name="phoneNumber" placeholder={this.state.oneMember.phoneNumber}
                                    value={this.state.phoneNumber}
                                    onChange={this.onChange}
                                />
                            </div>
                            <div className="form-group-create">
                                <h5> العنوان </h5>
                                <input type="text" className="form-control-form-cont" name="address" placeholder={this.state.oneMember.address}
                                    value={this.state.address}
                                    onChange={this.onChange}
                                />
                            </div>

                            <div className="form-group-create">
                                <h5> رقم الهويّة </h5>
                                <input type="text" className="form-control-form-cont" name="identity" placeholder={this.state.oneMember.identity}
                                    value={this.state.identity}
                                    onChange={this.onChange}
                                />
                            </div>
                            <div className="form-group-create">
                                <h5> تاريخ الميلاد </h5>
                                {/* <h5>{this.state.birthdate}</h5> */}
                                   <Calendar className="react-calendar"
                                    onChange={this.onChangeDate}
                                    // value={Moment(this.state.birthdate).format('DD-MM-YYYY')}
                                    />
                            </div>

                            <div className="form-group-create">
                                <h5> الجنس </h5>
                                <select className="form-control-form-cont" name="gender" onChange={this.onChange} >
                                    <option value="">{this.state.oneMember.gender && "ذكر"} </option>
                                    <option value="female">انثى</option>
                                    <option value="male">ذكر</option>
                                </select>        
                            </div>
                            <div className="form-group-create">
                                <h5> الحالة الاجتماعيّة - متزوج؟ </h5>
                                <select className="form-control-form-cont" name="isMarried" onChange={this.onChange} >
                                    <option value="">{this.state.oneMember.isMarried && "غير متزوج" } </option>
                                    <option value="yes">متزوج</option>
                                    <option value="no">غير متزوج</option>
                                </select>
                            </div>
                            <div className="form-group-create">
                                <h5> على قيد الحياة؟</h5>
                                <select className="form-control-form-cont" name="isAlive" onChange={this.onChange} >
                                    <option value="yes">{this.state.oneMember.isAlive && "نعم"} </option>
                                    <option value="yes">عايش</option>
                                    <option value="no"> متوفي</option>
                                </select>
                            </div>
                          
                            <input type="submit" value="ارسال" className="btn btn-primary btn-block mt-4" />

                        </form>

                        <div className="card-group-field">
                            <h4>   {translate("partner")}    </h4>
                            <h4> 
                             <button className="btn-edit" onClick={() => this.addPartner(this.state.oneMember.id)}> {translate("addPartner")}   </button>
                                {this.state.partners.length > 0 &&
                              this.state.partners.map(partner => (  
                                <div className="edit-actions">
                               <AiOutlineCloseCircle onClick={() => { if (window.confirm('Are you sure you want to delete this partner?')) this.deletePartner(partner.id) }} size={17} color="#FF0000" />
                            <button className="btn-reset" onClick={() => this.showPartner(partner.id)}> {partner.name}  </button> 
                            </div>
                           ))
                        }
                        </h4>
                          
                        </div>

                        <div className="card-group-field">
                            <h4>   {translate("children")}    </h4>
                            <h4> 
                            <button className="btn-edit" onClick={() => this.gotoAddChild(this.state.oneMember.id)}> {translate("add-child")}   </button>
                                {this.state.children.length > 0 &&                               
                              this.state.children.map(child => (     
                                <div className="edit-actions">
                                        <AiOutlineCloseCircle onClick={() => { if (window.confirm('Are you sure you want to delete this child?')) this.deleteMemberClicked(child.id) }} size={17} color="#FF0000" />
                                       <button className="btn-reset" onClick={() => this.gotoMemberProfile(child.id)}> {child.name} </button> 

                                  </div>
                           
                           ))
                        }
                        </h4>
                          
                        </div>

                        <div className="card-group-field">
                        <h4>   {translate("profile-pic")}    </h4>
                         <button className="btn-edit" onClick={() => this.gotoUpalodProfilePicture(this.state.oneMember.id)}>{translate("edit-profile-pic")}  </button>
                         </div>
                        <button className="btn" onClick={this.props.history.goBack}> للعودة  </button>
                    </div>

                </div></div>


        )
    }

}